import { jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import '../Button/index.js';
import { ButtonUnstyled } from '../Button/ButtonUnstyled.js';

const tabStyle = css `
  border: 1px solid transparent;
  color: ${({ selected, theme }) => selected
    ? theme.colors.foreground.secondary.A
    : theme.colors.foreground.secondary.C};
  display: inline-block;
  font-size: 0.6875rem;
  line-height: 1.4;
  font-family: ${({ theme }) => theme.fonts.buttons};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  padding: 10px 16px; /* stylelint-disable-line scales/space */
  position: relative;
  text-align: center;
  text-transform: uppercase;
  transition: all ${({ theme }) => theme.transitions.duration[1]};
  user-select: none;
  white-space: nowrap;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : undefined)};

  &:hover,
  &:focus,
  &:active {
    color: ${({ theme }) => theme.colors.foreground.secondary.A};
  }

  ${({ selected, borderPosition, theme, }) => `${borderPosition === 'bottom' ? 'border-bottom' : 'border-top'}: ${selected ? `2px solid ${theme.colors.sketch.A}` : '2px solid transparent'};`}
`;
const TabButton = styled(ButtonUnstyled) `
  ${tabStyle};
`;
const TabDiv = styled.span `
  cursor: pointer;

  ${tabStyle};
`;
const TabOld = ({ children, selected = false, borderPosition = 'top', urlFragment, onTabSelected, className, isDisabled, }) => (jsx("li", Object.assign({ className: className }, { children: urlFragment ? (jsx(NavLink, Object.assign({ to: `#${urlFragment}` }, { children: jsx(TabDiv, Object.assign({ selected: selected, borderPosition: borderPosition, onClick: onTabSelected, disabled: isDisabled }, { children: children })) }))) : (jsx(TabButton, Object.assign({ selected: selected, borderPosition: borderPosition, onClick: onTabSelected, disabled: isDisabled }, { children: children }))) })));

export { TabButton, TabDiv, TabOld };
